import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT, LIMIT_PAGE } from "constants/variables"; 
import Box from '@mui/material/Box'; 
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress'
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types';
import TableSortingContractEmployee from 'pages/contracts/editOrNewContract/SortingTablesContractEmpoyee'; 

const initialFiltersEmployee= {
  "idFrom":"",
  "idTo":"",
  "firstnameFrom":"",
  "firstnameTo":"",
  "lastname1From":"",
  "lastname1To":"",
  "lastname2From":"",
  "lastname2To":"",
  "enabled":true,
  "notenabled":true
};
 
const initialStateEmployee = [{
  "id" : "",
  "firstname" : "",
  "lastname1" : "",
  "lastname2" : "",
  "documnettype_id" : 2, 
  "numberdocument":"",
  "phone" : "",
  "email" : "",
  "enabled" : "" 
}];
        

const ContractSearchEmployees = ({ showModalSearchEmployees, setShowModalSearchEmployees,setFormContract}) => {
  const {t,i18n} = useTranslation(['listDataContracts']);
  const state = useSelector((state) => state);
  const {token} = state.loginUser
  const [dataEmployee, setDataEmployee] = useState(initialStateEmployee);
  const [filtersEmployee, setFiltersEmployee]= useState(initialFiltersEmployee);
  const [applyFiltersEmployee, setApplyFiltersEmployee]= useState(initialFiltersEmployee);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegEmployee,setNumTotRegEmployee]= useState(0);
  const [errorsFiltersEmployee, setErrorsFiltersEmployee] = useState({});
  const [inputTextEmployee, setInputTextEmployee] = useState("");
  const [openEditFilterEmployee,setOpenEditFilterEmployee]= useState(false);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorEmployee, setIsLoadingErrorEmployee] = useState(false);
  const [activeOffsetEmployee, setActiveOffsetEmployee]= useState(false);
  const [currencyOffsetEmployee, setCurrencyOffsetEmployee] = useState(0);
  const [rangeOffsetEmployee, setRangeOffsetEmployee] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && setShowModalSearchEmployees) {
        setDataEmployee(initialStateEmployee);
        setFiltersEmployee(initialFiltersEmployee);
        setApplyFiltersEmployee(initialFiltersEmployee);
        setNumTotRegFilter(0);
        setNumTotRegEmployee(0);
        setErrorsFiltersEmployee({});
        setInputTextEmployee("");
        setOpenEditFilterEmployee(false); 
        setIsLoadingErrorEmployee(false);
        setActiveOffsetEmployee(false);
        setCurrencyOffsetEmployee(0);
        setRangeOffsetEmployee([{}]);
        setShowModalSearchEmployees(false);
      }
    },
    [ setDataEmployee,
      setFiltersEmployee,
      setApplyFiltersEmployee,
      setNumTotRegFilter,
      setNumTotRegEmployee,
      setErrorsFiltersEmployee,
      setInputTextEmployee,
      setOpenEditFilterEmployee, 
      setIsLoadingErrorEmployee,
      setActiveOffsetEmployee,
      setCurrencyOffsetEmployee,
      setRangeOffsetEmployee, 
      setShowModalSearchEmployees
    ]
  );

  const handleCloseDataEditEmployee = () => {
    setDataEmployee(initialStateEmployee);
    setFiltersEmployee(initialFiltersEmployee);
    setApplyFiltersEmployee(initialFiltersEmployee);
    setNumTotRegFilter(0);
    setNumTotRegEmployee(0);
    setErrorsFiltersEmployee({});
    setInputTextEmployee("");
    setOpenEditFilterEmployee(false); 
    setIsLoadingErrorEmployee(false);
    setActiveOffsetEmployee(false);
    setCurrencyOffsetEmployee(0);
    setRangeOffsetEmployee([{}]);
    setShowModalSearchEmployees(false); 
	};

  const toggleDrawerSearchFormEmployees  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditEmployee();
    }
  };

  const openEditFiltersEmployee = () => {
    setFiltersEmployee(applyFiltersEmployee);
    setOpenEditFilterEmployee(!openEditFilterEmployee);
  };

  const handleSubmitFilterEditStore = () => {
    setErrorsFiltersEmployee(validateFormFilterEmployee());
    if (Object.keys(errorsFiltersEmployee).length === 0) {
      setApplyFiltersEmployee(filtersEmployee);
      setFiltersEmployee(initialFiltersEmployee);
      setErrorsFiltersEmployee({});
      setOpenEditFilterEmployee(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }

  const handleDeleteFiltersStore = () => {
    setErrorsFiltersEmployee({});
    setFiltersEmployee(initialFiltersEmployee);
    setApplyFiltersEmployee(initialFiltersEmployee);
    setOpenEditFilterEmployee(!openEditFilterEmployee);
  };

  const handleCancelFiltersEmployee = () => {
    setErrorsFiltersEmployee({});
    setFiltersEmployee(initialFiltersEmployee);
    setOpenEditFilterEmployee(!openEditFilterEmployee);
  };

  const handleChangeEnabledFilter = (e) => {
    setFiltersEmployee(filtersEmployee => ({
      ...filtersEmployee,
      enabled: !filtersEmployee.enabled
    }));
  };

  const handleChangeNotEnabledFilter = (e) => {
    setFiltersEmployee(filtersEmployee => ({
      ...filtersEmployee,
      notenabled: !filtersEmployee.notenabled
    }));
  };

  const handleChangeFilterEditEmployee = (e) => {
    const { name, value } = e.target;
    setFiltersEmployee(filtersEmployee => ({
      ...filtersEmployee,
      [name]: value
    }));
  };

  const handleBlurFilterEditEmployee = (e) => {
    setErrorsFiltersEmployee(validateFormFilterEmployee());
    handleChangeFilterEditEmployee(e);
  };

  const toggleDrawerFilterEditEmployee = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditEmployee();
    }
  }; 

  const validateFormFilterEmployee = () => {

    let errorsFiltersEmployee = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersEmployee.idFrom!=="" & !regexNumber.test(filtersEmployee.idFrom)) {
      errorsFiltersEmployee.idFrom = 'Text_TextNoNumber';
    }
    if (filtersEmployee.idTo!=="" & !regexNumber.test(filtersEmployee.idTo)) {
      errorsFiltersEmployee.idTo = 'Text_TextNoNumber';
    }
    if (filtersEmployee.idFrom!=="" & !errorsFiltersEmployee.idFrom!==undefined){
      if (filtersEmployee.idTo!=="" & !errorsFiltersEmployee.idTo!==undefined){
        if (parseInt(filtersEmployee.idTo)<parseInt(filtersEmployee.idFrom)){
          errorsFiltersEmployee.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersEmployee.firstnameFrom)) {
      errorsFiltersEmployee.firstnameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersEmployee.firstnameTo)) {
      errorsFiltersEmployee.firstnameTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersEmployee.lastname1From)) {
      errorsFiltersEmployee.lastname1From = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersEmployee.lastname1To)) {
      errorsFiltersEmployee.lastname1To = 'Text_TextNoValid';
    } 

    if (regexInvalidCharacters.test(filtersEmployee.lastname2From)) {
      errorsFiltersEmployee.lastname2From = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersEmployee.lastname2To)) {
      errorsFiltersEmployee.lastname2To = 'Text_TextNoValid';
    } 
  
    if (filtersEmployee.firstnameTo!=="" & filtersEmployee.firstnameTo<filtersEmployee.firstnameFrom){
      errorsFiltersEmployee.firstnameTo = 'Text_TextGreater_firstname';
    }

    if (filtersEmployee.lastname1To!=="" & filtersEmployee.lastname1To<filtersEmployee.lastname1From){
      errorsFiltersEmployee.lastname1To = 'Text_TextGreater_lastname1';
    }

    if (filtersEmployee.lastname2To!=="" & filtersEmployee.lastname2To<filtersEmployee.lastname2From){
      errorsFiltersEmployee.lastname2To = 'Text_TextGreater_lastname2';
    }

    return errorsFiltersEmployee;
  }  

  const filteredDataEmployee = dataEmployee.filter((el) => {
    if (inputTextEmployee === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.firstname || '') +
        String(el.lastname1 || '') +
        String(el.lastname2 || '') +
        String(el.numberdocument || '');
      let result = dataTranslate.toLowerCase().includes(inputTextEmployee.toLowerCase());
      return result;
    }
  })

  let inputHandlerEmployee = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextEmployee(lowerCase);
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
  useEffect(() => {
    if (numTotRegEmployee > LIMIT_PAGE) {
      setActiveOffsetEmployee(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMIT_PAGE); i < numTotRegEmployee; i += Number(LIMIT_PAGE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetEmployee(newRangeOffset);
    } else {
      setCurrencyOffsetEmployee(0);
      setActiveOffsetEmployee(false);
      setRangeOffsetEmployee([{}]);
    }
  }, [numTotRegEmployee]);

  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegEmployee = async () => { 
      try {
        const getData = await helpHttp().get(ENDPOINT, `contract/getinformationtableemployee`, token);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataEmployee(initialStateEmployee); 
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setNumTotRegEmployee(getData);
        }

      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT, `contract/getcountfilteremployee`, token, applyFiltersEmployee);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataEmployee(initialStateEmployee);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchDataEmployee = async () => {
      try { 
        const getData = await helpHttp().get3(ENDPOINT, `contract/getemployees`, token, currencyOffsetEmployee, LIMIT_PAGE, applyFiltersEmployee);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataEmployee(initialStateEmployee);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setDataEmployee(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (showModalSearchEmployees){
      fetchnumTotRegEmployee();
      fetchnumTotRegFilter();
      fetchDataEmployee();
      return () => { isMounted = false; };
    }
  }, [t,token,dispatch,i18n.language,showModalSearchEmployees,applyFiltersEmployee,currencyOffsetEmployee]);

return(
    <>
      {showModalSearchEmployees && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormEmployees(false)}
            onOpen={toggleDrawerSearchFormEmployees(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1100px' }}>
                <br/>
                <div id="myDIV">
                  <h1 className="h1NewStyle px-4 mb-2">
                    {isLoadingErrorEmployee?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_CONTRACT_Employees_Search')}
                  </h1>
                   <div>
                    <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataEditEmployee} >
                      {t("Button_Exit")}
                    </button>
                  </div> 
                  </div>  
                <br/>
                <br/>
                <div className="formdi-pending-search">
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextEmployee}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                    placeholder={t('Text_Employee_Search')} 
                    onChange={inputHandlerEmployee}
                    fullWidth
                    label={t('Text_Employee_Search')}>
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV" className="formdi-pending-filters">
                  <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
                  <div className="formdi-pending-filters-row">
                    <button type="button" className={`formdi-pending-chip ${applyFiltersEmployee.firstnameFrom!=="" || applyFiltersEmployee.firstnameTo!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersEmployee} >
                      <span className={`formdi-pending-dot ${applyFiltersEmployee.firstnameFrom!=="" || applyFiltersEmployee.firstnameTo!==""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_name")}
                    </button>
                    <button type="button" className={`formdi-pending-chip ${applyFiltersEmployee.lastname1From!=="" || applyFiltersEmployee.lastname1To!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersEmployee} >
                      <span className={`formdi-pending-dot ${applyFiltersEmployee.lastname1From!=="" || applyFiltersEmployee.lastname1To!==""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_CONTRACT_EMPLOYEEE_lastname1")}
                    </button>
                     <button type="button" className={`formdi-pending-chip ${applyFiltersEmployee.lastname2From!=="" || applyFiltersEmployee.lastname2To!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersEmployee} >
                      <span className={`formdi-pending-dot ${applyFiltersEmployee.lastname2From!=="" || applyFiltersEmployee.lastname2To!==""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_CONTRACT_EMPLOYEEE_lastname2")}
                    </button>
                    <button type="button" className={`formdi-pending-chip ${applyFiltersEmployee.enabled? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersEmployee} >
                      <span className={`formdi-pending-dot ${applyFiltersEmployee.enabled? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Filter_Employee_Habilty")}
                    </button>
                    <button type="button" className={`formdi-pending-chip ${applyFiltersEmployee.notenabled? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersEmployee} >
                      <span className={`formdi-pending-dot ${applyFiltersEmployee.notenabled? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Filter_Employee_Not_Habilty")}
                    </button>
                    </div>
                </div>
                <br/>
                {!isLoadingData ?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">
                        <TableSortingContractEmployee
                          dataEmployee={filteredDataEmployee}
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={t('Text_Employees_Table')}
                          numTotRegEmployee={numTotRegEmployee}
                          activeOffsetEmployee={activeOffsetEmployee}
                          rangeOffsetEmployee={rangeOffsetEmployee}
                          currencyOffsetEmployee={currencyOffsetEmployee}
                          setCurrencyOffsetEmployee={setCurrencyOffsetEmployee} 
                          setFormContract={setFormContract}
                          handleCloseDataEditEmployee={handleCloseDataEditEmployee}
                        >
                        </TableSortingContractEmployee>
                      </div>             
                    </div>
                    {openEditFilterEmployee &&
                      <div>
                        <SwipeableDrawer
                          anchor='right'
                          open={true}
                          onClose={toggleDrawerFilterEditEmployee(false)}
                          onOpen={toggleDrawerFilterEditEmployee(true)}>
                          <Container >
                            <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1100' }}>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div> 
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form className="newfilterformstore" onSubmit={handleCancelFiltersEmployee}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  <div className="form-group">
                                    <TextField
                                      id="firstnameFrom" 
                                      name="firstnameFrom"
                                      value={filtersEmployee.firstnameFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersEmployee.firstnameFrom!=null?t(errorsFiltersEmployee.firstnameFrom):t('Text_Filter_firstname_From')}
                                      placeholder={t('PlaceHolder_Filter_firstname_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditEmployee}
                                      onChange={handleChangeFilterEditEmployee}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="firstnameTo" 
                                      name="firstnameTo"
                                      value={filtersEmployee.firstnameTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersEmployee.firstnameTo!=null?t(errorsFiltersEmployee.firstnameTo):t('Text_Filter_firstname_To')}
                                      placeholder={t('PlaceHolder_Filter_firstname_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditEmployee}
                                      onChange={handleChangeFilterEditEmployee}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="lastname1From" 
                                      name="lastname1From"
                                      value={filtersEmployee.lastname1From}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersEmployee.lastname1From!=null?t(errorsFiltersEmployee.lastname1From):t('Text_Filter_lastname1_From')}
                                      placeholder={t('PlaceHolder_Filter_lastname1_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditEmployee}
                                      onChange={handleChangeFilterEditEmployee}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="lastname1To" 
                                      name="lastname1To"
                                      value={filtersEmployee.lastname1To}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersEmployee.lastname1To!=null?t(errorsFiltersEmployee.lastname1To):t('Text_Filter_lastname1_To')}
                                      placeholder={t('PlaceHolder_Filter_lastname1_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditEmployee}
                                      onChange={handleChangeFilterEditEmployee}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="lastname2From" 
                                      name="lastname2From"
                                      value={filtersEmployee.lastname2From}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersEmployee.lastname2From!=null?t(errorsFiltersEmployee.lastname2From):t('Text_Filter_lastname2_From')}
                                      placeholder={t('PlaceHolder_Filter_lastname2_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditEmployee}
                                      onChange={handleChangeFilterEditEmployee}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <TextField
                                      id="lastname2To" 
                                      name="lastname2To"
                                      value={filtersEmployee.lastname2To}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsFiltersEmployee.lastname2To!=null?t(errorsFiltersEmployee.lastname2To):t('Text_Filter_lastname2_To')}
                                      placeholder={t('PlaceHolder_Filter_lastname2_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditEmployee}
                                      onChange={handleChangeFilterEditEmployee}/>
                                  </div>
                                  <div className="form-group">
                                      <Checkbox
                                        id="enabled" 
                                        name="enabled"
                                        checked={filtersEmployee.enabled}
                                        onChange={handleChangeEnabledFilter}
                                        variant="standard"
                                        sx={{
                                          '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                        }}
                                      />
                                      &nbsp;&nbsp;    
                                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Employee_Habilty')}</label>  
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <Checkbox
                                        id="notenabled" 
                                        name="notenabled"
                                        checked={filtersEmployee.notenabled}
                                        onChange={handleChangeNotEnabledFilter}
                                        variant="standard"
                                        sx={{
                                          '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                        }}
                                      />
                                      &nbsp;&nbsp;    
                                      <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Employee_Not_Habilty')}</label>    
                                  </div>
                                </div>
                                 <hr className="sidebar-divider d-none d-md-block" />
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditStore}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersStore}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>    
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }   
                  {/* End Content Row */}
                  </>:
                     <LoadingNews/>
                }     
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ContractSearchEmployees.propTypes = {
  showModalSearchEmployees: PropTypes.bool.isRequired,
  setShowModalSearchEmployees: PropTypes.func.isRequired, 
  setFormContract: PropTypes.func.isRequired
};

export default ContractSearchEmployees;
